import fetch from '@/plugin/axios'

// 获取弹窗信息
export function getGiftInfo (query) {
  return fetch({
    url: '/api/common/pop-window/list',
    method: 'Post',
    data: query
  })
}

// 新增
export function addGiftInfo (query) {
  return fetch({
    url: '/api/common/pop-window/add',
    method: 'Post',
    data: query
  })
}

// 弹窗信息
export function getDetailGiftInfo (query) {
  return fetch({
    url: '/api/common/pop-window/info/' + query,
    method: 'Get'
  })
}

// 修改详情列表
export function updateGiftInfo (id, query) {
  return fetch({
    url: '/api/common/pop-window/update/' + id,
    method: 'Post',
    data: query
  })
}
